import * as api from '../../api'
import router from '../../../router'
import * as types from '../../mutation-types'

const state = {
  server_objects: [],
  server_object: {
    contents: ''
  }
}

const getters = {
  allServerObjects: state => state.server_objects,
  singleServerObject: state => state.server_object
}

const actions = {
  getServerObjects ({ commit }, directory) {
    api.instance.get('server_objects', { params: { directory: directory } })
      .then(function (response) {
        if (response.data.success !== 'false') {
          const serverObjects = response.data
          commit(types.RECEIVE_SERVER_OBJECTS, serverObjects)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getServerObject ({ commit }, filePath) {
    api.instance.get('server_object', { params: { file_path: filePath } })
      .then(function (response) {
        const serverObject = response.data
        commit(types.RECEIVE_SERVER_OBJECT, serverObject)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  editServerObject ({ commit }, data) {
    api.instance.put('server_object', { file_path: data.file_path, file_contents: data.file_contents })
      .then(function (response) {
        if (response.data.success === 'true') {
          router.push({ name: 'AdminMachineTFTPIndex' })
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  uploadServerObjects ({ commit }, data) {
    let formData = new FormData()

    Array.from(Array(data.files.length).keys()).map(i => {
      formData.append(data.files[i].name, data.files[i], data.files[i].name)
    })
    formData.append('directory', data.directory)

    api.instance.post('server_objects', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        alert(response.data.message)
        if (response.data.success === 'true') {
          commit(types.RECEIVE_SERVER_OBJECTS, response.data.server_objects)
        }
      })
  },
  deleteServerObjects ({ commit }, data) {
    let formData = new FormData()

    Array.from(Array(data.checked_files.length).keys()).map(i => {
      formData.append('file' + i, data.checked_files[i])
    })
    formData.append('directory', data.directory)

    if (data.checked_files.length > 0) {
      api.instance.delete('server_objects', { data: { directory: data.directory, checked_files: data.checked_files } })
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.RECEIVE_SERVER_OBJECTS, response.data.server_objects)
          }
        })
    }
  }
}

const mutations = {
  [types.RECEIVE_SERVER_OBJECTS] (state, serverObjects) {
    state.server_objects = serverObjects
  },
  [types.RECEIVE_SERVER_OBJECT] (state, serverObject) {
    state.server_object.contents = serverObject
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
